module.exports = __webpack_public_path__ + "static/media/cat2.e0918cec.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat2.jpeg
// module id = 34
// module chunks = 0